
export default {
  name: 'OverlayGridItemMedia',

  props: {
    mouseover: Boolean,
    portrait: Boolean,
    muted: Boolean,
    artificialHover: Boolean,
    enableOpacity: Boolean,
    enableLabel: Boolean,
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data () {
    return {
      mutedModel: this.muted,
      videoLoaded: false
    }
  },

  computed: {
    imageAspectRatioProps () {
      return (
        this.portrait
          ? { width: 300, height: 534, style: 'aspect-ratio: 300 / 534' }
          : { width: 300, height: 169, style: 'aspect-ratio: 300 / 169' }
      )
    },

    imageUrl () {
      const imageBaseUrl = this.portrait ? this.product.discovery_image_portrait_url || this.product.discovery.image_portrait_url : this.product.discovery_image_url || this.product.discovery.image_url

      if (!imageBaseUrl) {
        return
      }

      return imageBaseUrl + '?width=300'
    },

    videoUrl () {
      let videoUrl = null

      if (this.portrait) {
        videoUrl = this.product.discovery_video_portrait_url
      } else {
        videoUrl = this.product.discovery_video_url
      }

      if (videoUrl && ['.mp4', '.webm', '.gif'].some(format => videoUrl.includes(format))) {
        return videoUrl
      }

      return null
    }
  },

  watch: {
    mutedModel (newValue) {
      this.$emit('update:muted', newValue)
    },

    muted (newValue) {
      this.mutedModel = newValue
    }
  },

  methods: {
    togglMute () {
      this.mutedModel = !this.mutedModel

      if (this.$refs.video) {
        this.$refs.video.muted = this.mutedModel
      }
    }
  }
}
